import React, { createContext, useContext, useState } from 'react';

const TimingContext = createContext();

export function TimingProvider({ children }) {
  const [timings, setTimings] = useState([]);

  const logTiming = (timing) => {
    setTimings(prev => [...prev, timing]);
  };

  return (
    <TimingContext.Provider value={{ timings, logTiming }}>
      {children}
    </TimingContext.Provider>
  );
}

export function useTiming() {
  return useContext(TimingContext);
}
